import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useAuthContext } from '../../../context/useAuthContext';
import { /*GET_BRANDS, */CREATE_BRAND } from '../../../queries';

const useCreate = (navigation, where) => {
  const { token } = useAuthContext();
  const context = {headers: {Authorization: `Bearer ${token}`}};
  const [createBrand] = useMutation(CREATE_BRAND, { context });
  const [state, setState] = useState({ creating: false, errorCreating: null });

  const handle = async (data) => {
    setState({ creating: true, errorCreating: null });
    try {
      const x = await createBrand({
        variables: {data: { 
          ...data
        }},
        // awaitRefetchQueries: true,
        // refetchQueries: [
        //   { query: GET_BRANDS, variables: { where }, context }
        // ]
      });
      setState({ creating: false, errorCreating: null });
      navigation.navigate('search');
    } catch (error) {
      setState({ creating: false, errorCreating: error });
    }
  }

  return [handle, { ...state }];
}

export default useCreate;